<template>
  <div class="withdraw-user" :style="{'background': background}">
    <div class="flipper">
      <img src="../images/flipper_front@2x.png" class="front">
      <img src="../images/flipper_back@2x.png" class="back">
    </div>
    <div class="info-container">
      <div>手机尾号{{ currentUser.mobile }}</div>
      <div>{{ infoText }}<span class="amount" :style="{'color': amountTextColor}"> {{ currentUser.amount }} </span>元</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WithdrawUserFlipper',
  props: {
    // 组件背景色
    background: {
      type: String,
      default: ''
    },
    // 金额文字颜色
    amountTextColor: {
      type: String,
      default: '#FFD08B'
    },
    infoText: {
      type: String,
      default: '插队高通资方到账'
    },
    // 循环用户信息
    users: {
      type: Array,
      default: () => [{}]
    }
  },
  data () {
    return {
      flipAnimation: null,
      expandAnimation: null,
      currentUser: {}
    }
  },
  mounted () {
    this.beginAnimation()
    // 初始化展示第一个用户信息
    this.currentUser = this.getNextUser()
  },
  beforeDestroy () {
    clearInterval(this.flipAnimation)
    clearInterval(this.expandAnimation)
  },
  methods: {
    beginAnimation () {
      let _this = this
      this.expandAnimation = setInterval(function () {
        var flipContainer = document.querySelector('.withdraw-user')
        flipContainer.classList.toggle('expanded')
      }, 3600)
      setTimeout(() => {
        this.flipAnimation = setInterval(function () {
          var flipContainer = document.querySelector('.withdraw-user')
          flipContainer.classList.toggle('flipped')
          if (!flipContainer.classList.contains('flipped')) {
            // 展示下一个用户信息
            _this.currentUser = _this.getNextUser()
          }
        }, 3600)
      }, 300)
    },
    getNextUser () {
      // 循环获取users中的用户信息，如果已经展示完毕，则重新开始
      let index = 0
      if (this.currentUser.mobile) {
        index = this.users.findIndex(user => user.mobile === this.currentUser.mobile)
        index = index === this.users.length - 1 ? 0 : index + 1
      }
      return this.users[index]
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.withdraw-user {
  width: 110px;
  height: 110px;
  border-radius: 55px;
  margin-top: 39px;
  margin-left: 50px;
  padding-left: 10px;
  transition: width 0.6s;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  position: relative;
  .flipper {
    width: 90px;
    height: 90px;
    transform-style: preserve-3d;
    transition: transform 0.6s; /* 添加翻转动画的过渡效果 */
  }
  .front, .back {
    width: 90px;
    height: 90px;
    position: absolute;
    backface-visibility: hidden;
    border-radius: 100%;
    flex: 0 0 auto;
  }
  .back {
    transform: rotateY(180deg);
  }
  .info-container {
    overflow: hidden;
    font-size: 26px;
    color: white;
    text-align: left;
    line-height: 37px;
    white-space: nowrap;
    flex: 1;
    margin-left: 20px;
  }
}
.withdraw-user.flipped .flipper{
  transform: rotateY(180deg);
}
.withdraw-user.expanded {
  width: 650px;
}
</style>